/**
 * Feb 2026 · Mobile Read-Only Watermark.
 *
 * Fixed pill in the bottom-right corner of mobile viewports that
 * signals to operators the app is in monitor-only mode. Sits just
 * above the BottomNav (accounts for its ~64 px height + safe-area
 * inset). Hidden on desktop.
 */
import { LockKeyIcon } from "@phosphor-icons/react";
import { useIsMobile } from "@/lib/mobile.jsx";

export default function ReadOnlyBadge() {
  const isMobile = useIsMobile();
  if (!isMobile) return null;
  return (
    <div
      data-testid="mobile-read-only-badge"
      className="fixed right-3 z-40 flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-amber-500/50 bg-amber-500/10 text-amber-300 text-[10px] font-mono font-semibold uppercase tracking-widest backdrop-blur-md shadow-lg shadow-black/40"
      style={{ bottom: "calc(76px + env(safe-area-inset-bottom, 0px))" }}
      aria-label="Read-only mode active"
    >
      <LockKeyIcon size={11} weight="fill" />
      Read-Only
    </div>
  );
}
